import React from 'react'
import { Typography } from '@mui/material'

import useStyle from 'shared/hooks/useStyle'

import styles from './EmptyStepContent.style'

type Props = {
    title: string,
    customClasses?: {
        noPictureText?: string,
        text?: string,
    }
}

const EmptyStepContent = ({
    title,
    customClasses,
}: Readonly<Props>) => {
    const classes = useStyle(styles)

    return (
        <div css={[
            classes.noPicture,
            customClasses?.text,
        ]}
        >
            <Typography
                variant="h3"
                css={[
                    classes.text,
                    customClasses?.noPictureText,
                ]}
            >
                {title}
            </Typography>
        </div>
    )
}

export default EmptyStepContent
